import request from '@/utils/request'

/**
 * 分类网站列表
 */
export function categorySiteList() {
  return request({
    url: '/client/nav/category/site/list/',
    method: 'get'
  })
}
/**
 * 按域名获取网站列表
 */
export function categorySiteListByDomain(siteDomain) {
  return request({
    url: `/client/nav/category/site/listbydomain/${siteDomain}`,
    method: 'get'
  })
}
/**
 * 按分类网站列表
 */
export function SiteListBycategory(id, siteDomain) {
  return request({
    url: `/client/nav/category/site/list/${id}/${siteDomain}`,
    method: 'get'
  })
}
/**
 * 获取推荐列表
 */
export function RecommendSiteListBycategory(siteDomain) {
  return request({
    url: `/client/nav/category/Recommend/list/${siteDomain}`,
    method: 'get'
  })
}
/**
 * 分类列表
 */
export function categoryList() {
  return request({
    url: '/client/nav/category/list',
    method: 'get'
  })
}
